import { uniq } from 'lodash';

/**
 * Resolves the namespaced platform roles stored on a user-profile document down to promo's bare
 * role names for one tenant - ADR-016 - https://github.com/owg-digital/rtls-one-retail/tree/main/frontend/shell/docs/adrs/016-authorization-responsibility-split.md
 *
 *   '<role>'                   platform-wide: every app, every tenant
 *   'promo/<role>'             promo, every tenant
 *   'promo/<tenant>/<role>'    promo, that tenant only
 *
 * The document is tenant-agnostic and holds promo's slice of the JWT claim verbatim, so a reader
 * resolves it against the tenant it displays. The app segment needs no check — the server filtered
 * it on write. Fail closed: without a tenant only the tenant-agnostic grants survive. Standalone,
 * the roles are already bare names and pass through.
 *
 * @param {Array} roles - The `roles` array as stored on the profile document.
 * @param {String} tenantKey - The tenant the caller is displaying.
 */
const resolveRolesForTenant = (roles, tenantKey) => {
    return uniq(
        (roles || []).reduce((acc, role) => {
            const segments = String(role).split('/');
            if (segments.length === 1) acc.push(role);
            else if (segments.length === 2) acc.push(segments[1]);
            else if (segments.length === 3 && tenantKey && segments[1] === tenantKey) {
                acc.push(segments[2]);
            }
            return acc;
        }, [])
    );
};

export default { resolveRolesForTenant };
